import * as DayStyles from './components/Day/Day.css';
import * as SliderStyles from './components/Slider/Slider.css';
const defaultTheme = {
    DayStyles,
    SliderStyles
};
export default defaultTheme;
